/* eslint-disable react/jsx-props-no-spreading */
import { FunctionComponent, useCallback, useState } from 'react';
import { Drawer as DrawerComponent } from './Drawer';
import { DrawerProps } from './types';

export const useDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const Drawer = useCallback<FunctionComponent<DrawerProps>>(
    props => <DrawerComponent {...props} setIsOpen={setIsOpen} />,
    [],
  );

  const toggle = useCallback(() => {
    setIsOpen(open => !open);
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { Drawer, isOpen, toggle, open, close };
};
